import React from "react"
import ActiveAvatar from "avatar/maya-ship.svg"
import InactiveAvatar from "avatar/maya-ship-inactive.svg"

const MayaShip = ({ inactive, className = "", ...rest }) => {
  if (inactive) {
    return <img src={InactiveAvatar} className={`inactive ${className}`} {...rest} />
  }
  return <img src={ActiveAvatar} className={className} {...rest} />
}

export default MayaShip
